import type { Contract, ContractQueryParam } from "../../../../common/types/contract";
import { SIGN_ORIGIN } from "../../../../common/enum/common";
import httpRequest from "./index";
import type { PurchaseContract, Page } from "@zhihaoscm/entity";
import { analysisState } from "@/api/legacy";

// 项目管理
class ContractService {
    private readonly path: string;
    private service: any;

    constructor(path: string, service: any) {
        this.path = path;
        this.service = service;
    }

    /** 分页查询 */
    public async paging(params: ContractQueryParam): Promise<Page<Contract>> {
        const { data } = await this.service.get(`${this.path}/paging`, { params });
        return data;
    }

    // 签署
    public async sign(id: string): Promise<{ pageUrl: string; ticket: string; errors: unknown[]; status: number }> {
        const { data } = await this.service.get(`${this.path}/sign/${id}?origin=${SIGN_ORIGIN.PC.code}`);
        return data;
    }

    /** 获取详情 */
    async getInfo(id: number | string): Promise<PurchaseContract> {
        const { data: info } = await this.service.get(`${this.path}/find/${id}`);
        info.sigingState = info.state;
        info.state = analysisState.getNormalState(info.state);
        return info;
    }

    /**根据项目id和类型查询合同列表 */
    async listByProjectIdAndType(projectId: number, type: number, buyerId?: number): Promise<Contract[]> {
        const { data } = await this.service.get(`${this.path}/project-id/${projectId}/type/${type}`, {
            params: { buyerId }
        });
        return data;
    }

    /**
     * 作废采购合同
     */
    async startInvalid(id: number): Promise<{
        pageUrl: string;
        ticket?: string;
        errors: unknown[];
        status: number;
    }> {
        const { data } = await this.service.put(`${this.path}/invalid/${id}?origin=${SIGN_ORIGIN.PC.code}`);
        return data;
    }
}
export const contractService = new ContractService("/purchase/contract", httpRequest);
